/**
 * Created by rorschach on 2018/2/7.
 */
/* eslint-disable  */
import "babel-polyfill";
import "react";
import "react-dom";
import "mobx";
import "mobx-react";
import "react-router";
import "react-router-dom";
import "xyui";



// WEBPACK FOOTER //
// ./src/vendor.js